import { Injectable } from '@angular/core';
@Injectable()
export class SortingService {
    public standardArray = [];
    public selectableArray = [];
    public sortedAlphaOrderArray = [];
    constructor() { }

    sortAlternatives(array) {
        let swap;
        for (let i = 0; i < array.length - 1; i++) {
            for (let j = 0; j < array.length - i - 1; j++) {
                if ((JSON.stringify(array[j].code)) > (JSON.stringify(array[j + 1].code))) {
                    swap = array[j];
                    array[j] = array[j + 1];
                    array[j + 1] = swap;
                }
            }
        }
    }

    // sort as per the code 
    sortCodes(array, technicalData) {
        if (technicalData) {
            let swap;
            for (let i = 0; i < array.length - 1; i++) {
                for (let j = 0; j < array.length - i - 1; j++) {
                    if ((JSON.stringify(array[j].code)) > (JSON.stringify(array[j + 1].code))) {
                        swap = array[j];
                        array[j] = array[j + 1];
                        array[j + 1] = swap;
                    }
                }
            }
            this.sortChecked(array);
        } else {
            let swap;
            for (let i = 0; i < array.length - 1; i++) {
                for (let j = 0; j < array.length - i - 1; j++) {
                    if ((JSON.stringify(array[j].name)) > (JSON.stringify(array[j + 1].name))) {
                        swap = array[j];
                        array[j] = array[j + 1];
                        array[j + 1] = swap;
                    }
                }
            }
        }
    }

    // sorts standard, selected & selectable
    sortChecked(data: any) {
        let finalArr: any[] = data;
        let standArr: any[] = [];
        let selArr: any[] = [];
        let unselArr: any[] = [];

        finalArr.forEach(element => {
            if (element.selected) {
                selArr.push(element);
            }
        });

        finalArr.forEach(element => {
            if (element.selected === false) {
                unselArr.push(element);
            }
        });

        finalArr.length = 0;

        selArr.forEach(element => {
            finalArr.push(element);
        });
        unselArr.forEach(element => {
            finalArr.push(element);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/sorting.service.ts